function showRefreshUI(registration: ServiceWorkerRegistration) {
  let button = document.createElement('button');

  button.style.position = 'fixed';
  button.style.top = '0px';
  button.style.left = '0px';
  button.style.zIndex = '9999';
  button.style.height = '70px';
  button.style.padding = '10px';
  button.style.width = '100%';
  button.classList.add('update-message');

  button.innerHTML =
    // eslint-disable-next-line max-len
    '<div class="leading-snug">This site has updated. Please <a>click here</a> to refresh the changes.</div>';

  button.addEventListener('click', () => {
    if (!registration.waiting) {
      // Just to ensure registration.waiting is available before
      // calling postMessage()
      return;
    }

    button.disabled = true;

    // This part is important, since we are ignoring the skipWaiting: true
    // in the webpack.config.js file, by default the WorkboxPlugin.GenerateSW()
    // will add the code to listen to 'SKIP_WAITING' type messages
    // So, we are controlling when we want to let the service worker now when to skipWaiting()
    registration.waiting.postMessage({
      type: 'SKIP_WAITING',
    });
  });

  document.body.appendChild(button);
}

function onNewServiceWorker(registration: ServiceWorkerRegistration, callback: () => void) {
  if (registration.waiting) {
    // SW is waiting to activate. Can occur if multiple clients open and
    // one of the clients is refreshed.
    return callback();
  }

  function listenInstalledStateChange() {
    registration?.installing?.addEventListener('statechange', event => {
      // @ts-ignore
      if (event.target?.state === 'installed') {
        // A new service worker is available, inform the user
        callback();
      }
    });
  }

  if (registration.installing) {
    return listenInstalledStateChange();
  }

  // We are currently controlled so a new SW may be found...
  // Add a listener in case a new SW is found,
  registration.addEventListener('updatefound', listenInstalledStateChange);
}

// Based on the Workbox documentation &
// https://redfin.engineering/how-to-fix-the-refresh-button-when-using-service-workers-a8e27af6df68
export function registerServiceWorker(name: string, scope: string) {
  let refreshing = false;
  // When the user asks to refresh the UI, we'll need to reload the window
  navigator.serviceWorker.addEventListener('controllerchange', _event => {
    if (refreshing) return; // prevent infinite refresh loop when you use "Update on Reload"
    refreshing = true;
    console.log('Controller loaded');
    window.location.reload();
  });

  navigator.serviceWorker
    .register(`/${name}.js`, { scope })
    .then(registration => {
      // Track updates to the Service Worker.
      if (!navigator.serviceWorker.controller) {
        // The window client isn't currently controlled so it's a new service
        // worker that will activate immediately
        return;
      }

      registration
        .update()
        .then(updated => console.log('SW Updated', updated))
        .catch(error => console.log('Error updating', error));

      onNewServiceWorker(registration, () => {
        showRefreshUI(registration);
      });
    })
    .catch(error => console.error('Error registering the SW', error));
}
